// extracted by mini-css-extract-plugin
export default {"smile":"styles_smile__MwS0e","text":"styles_text__WTc-Z","errorBox":"styles_errorBox__T0zwX","errorContent":"styles_errorContent__orufm"};